import { usePlayer } from '../../player/PlayerContext';
import { VolumeIcon, MuteIcon } from '../icons';

export default function VolumeControl({ className = '' }) {
  const { volume, isMuted, setVolume, toggleMute } = usePlayer();
  const effective = isMuted ? 0 : volume;
  const pct = Math.round(effective * 100);

  return (
    <div className={`volume-wrap ${className}`} style={{ display: 'flex', alignItems: 'center', gap: 8, flex: className.includes('nps') ? 1 : undefined }}>
      <button
        className="icon-btn"
        onClick={toggleMute}
        aria-label={isMuted ? 'Unmute' : 'Mute'}
        aria-pressed={isMuted}
      >
        {isMuted || volume === 0 ? <MuteIcon /> : <VolumeIcon level={volume} />}
      </button>
      <input
        className={`range volume ${className.includes('nps') ? '' : ''}`}
        type="range"
        min={0}
        max={1}
        step={0.01}
        value={effective}
        onChange={(e) => setVolume(parseFloat(e.target.value))}
        aria-label="Volume"
        style={{ '--range-pct': `${pct}%`, flex: className.includes('nps') ? 1 : undefined }}
      />
    </div>
  );
}
